module.exports = __webpack_public_path__ + "static/img/introduction.a06dfd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction.jpg
// module id = JCjJ
// module chunks = 0